import {apiClient} from '@common/http/query-client';
import {message} from '@common/i18n/message';
import {toast} from '@common/ui/toast/toast';
import {useMutation} from '@tanstack/react-query';

export const useReportTitle = (
  titleId: string,
  data: {
    subject: string;
    reason: string;
  },
) => {
  return useMutation({
    mutationKey: ['report_title'],
    mutationFn: () => reportTitle(titleId, data),
    onSuccess() {
      toast(message('Your report was submitted successfuly'));
    },
    onError() {
      toast(message("You have already reported this title"))
    }
  });
};

export const reportTitle = (
  titleId: string,
  data: {
    subject: string;
    reason: string;
  },
): Promise<any> => {
  return apiClient
    .post(`titles/reports/clientReport/${titleId}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(r => {
      return r.data;
    })
    .catch(err => console.log(err));
};
